module.exports = __webpack_public_path__ + "img/pass_type_up.954d7aa7.jpg";